import { render, staticRenderFns } from "./EditFichaLocal.vue?vue&type=template&id=70f127e4&scoped=true&"
import script from "./EditFichaLocal.vue?vue&type=script&lang=js&"
export * from "./EditFichaLocal.vue?vue&type=script&lang=js&"
import style0 from "./EditFichaLocal.vue?vue&type=style&index=0&id=70f127e4&scoped=true&lang=css&"
import style1 from "./EditFichaLocal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f127e4",
  null
  
)

export default component.exports